import { useState } from 'react';
import { AdminConfirmDialog } from '@/components/shared/AdminConfirmDialog';
import { Button } from '@/components/ui/button';
import { notify } from '@/lib/notify';
import { useSetSupplierActive } from '../catalog/hooks/useStoreCatalog';
import type { CatalogSupplierRow } from '../catalog/types';
import { supplierActiveConfirm } from './supplierActive';
import { isFileTemplateSupplier } from './templateManual';

export function SupplierActiveControl({ supplier }: { supplier: CatalogSupplierRow }) {
    const setActive = useSetSupplierActive();
    const [open, setOpen] = useState(false);
    const nextActive = !supplier.isActive;
    const copy = supplierActiveConfirm({
        name: supplier.name,
        nextActive,
        manualCatalog: isFileTemplateSupplier(supplier),
    });

    const confirm = async () => {
        try {
            await setActive.mutateAsync({ slug: supplier.slug, isActive: nextActive });
            notify({
                type: 'ok',
                text: nextActive ? `${supplier.name} está activo` : `${supplier.name} está inactivo`,
            });
            setOpen(false);
        } catch (cause: unknown) {
            notify({ type: 'err', text: cause instanceof Error ? cause.message : String(cause) });
        }
    };

    return (
        <>
            <Button
                type="button"
                size="sm"
                variant={nextActive ? 'default' : 'outline'}
                onClick={() => setOpen(true)}
            >
                {nextActive ? 'Activar proveedor' : 'Desactivar proveedor'}
            </Button>
            <AdminConfirmDialog
                open={open}
                title={copy.title}
                description={copy.description}
                confirmLabel={copy.confirmLabel}
                variant={nextActive ? 'default' : 'danger'}
                confirmDisabled={setActive.isPending}
                onConfirm={() => { void confirm(); }}
                onCancel={() => { if (!setActive.isPending) setOpen(false); }}
            />
        </>
    );
}
